import { c as _c } from "react/compiler-runtime";
import React, { FunctionComponent } from 'react';
import { useNavigate } from 'react-router-dom';
import { useEventCallback } from 'record-it-components/hooks/useEventCallback';
import { prepareProps } from 'record-it-components/utils/propUtils';
import { PropsWithoutChildren } from 'record-it-components/utils/utilityTypes';
import { RoutePaths } from '../../../classes/RoutePaths/RoutePaths';
import { useRequiredWorkTimeEntryToCreate } from '../../../hooks/createWorkTimeEntry/useRequiredWorkTimeEntryToCreate';
import { useConfigureBreadcrumbsWithBuilder } from '../../../hooks/misc/useConfigureBreadcrumbsWithBuilder';
import { useAppDispatch } from '../../../store/hooks';
import { createWorkTimeEntrySlice } from '../../../store/slice/createWorkTimeEntry/createWorkTimeEntrySlice';
import { CreateConstructionSitePageContent, CreateConstructionSitePageContentProps } from '../../constructionSite/CreateConstructionSitePageContent/CreateConstructionSitePageContent';
export type CreateWorkTimeEntryCreateConstructionSitePageProps = PropsWithoutChildren<Record<never, never>>;
export const CreateWorkTimeEntryCreateConstructionSitePage: FunctionComponent<CreateWorkTimeEntryCreateConstructionSitePageProps> = React.memo(props => {
  const $ = _c(9);
  prepareProps({
    props,
    ignoreChildren: true
  });
  useConfigureBreadcrumbsWithBuilder(_temp);
  const workTimeEntryToCreate = useRequiredWorkTimeEntryToCreate();
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  let t0;
  if ($[0] !== dispatch || $[1] !== navigate) {
    t0 = container => {
      dispatch(createWorkTimeEntrySlice.actions.setConstructionSiteId(container.getLatest().id));
      navigate(RoutePaths.createWorkTimeEntry());
    };
    $[0] = dispatch;
    $[1] = navigate;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  const handleConstructionSiteCreated = useEventCallback(t0);
  let t1;
  if ($[3] !== navigate) {
    t1 = () => {
      navigate(RoutePaths.createWorkTimeEntrySelectConstructionSite());
    };
    $[3] = navigate;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  const handleCancel = useEventCallback(t1);
  let t2;
  if ($[5] !== handleCancel || $[6] !== handleConstructionSiteCreated || $[7] !== workTimeEntryToCreate.userGroupId) {
    t2 = <CreateConstructionSitePageContent userGroupId={workTimeEntryToCreate.userGroupId} onConstructionSiteCreated={handleConstructionSiteCreated} onCancel={handleCancel} data-testid="CreateWorkTimeEntryCreateConstructionSitePage.PageContent" />;
    $[5] = handleCancel;
    $[6] = handleConstructionSiteCreated;
    $[7] = workTimeEntryToCreate.userGroupId;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  return t2;
});
function _temp(builder) {
  return builder.addHomePage().addCreateWorkTimeEntryPage().addCreateWorkTimeEntrySelectConstructionSitePage().addCreateWorkTimeEntryCreateConstructionSitePage();
}